<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import Icon from "../components/Icon.svelte";
	import DecoratedHeadline from "../components/DecoratedHeadline.svelte";
	import arrowLeft from "../../../core/assets/icons/filled-arrow-left.svg?raw";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import contactMap from "../assets/images/contact-map.svg?raw";
	import ContactCard from "../components/ContactCard.svelte";
	import Contact from "../components/Contact.svelte";
	import type { ContactProps } from "./ContactProps.js";

	type $$Props = ContactProps;

	const { expert, management } = $$restProps as $$Props;

	const expertContactClasses: string[] = [
		"text-bito-yellow",
		"text-tertiary",
		"text-bito-orange",
		"text-[#920095]",
		"text-primary",
	];
</script>

<Layout>
	<button
		class="ml-6 mt-4 flex cursor-pointer gap-4 md:ml-10 md:mt-8"
		on:click={() => {
			history.back();
		}}
	>
		<Icon icon={arrowLeft} class="text-gray h-4 w-4" />
		<span class="text-xs font-extrabold">Zpět</span>
	</button>
	<div class="mx-auto mt-7 flex flex-col justify-center px-4">
		<DecoratedHeadline h1>Kontakty</DecoratedHeadline>
		<p
			class="mx-auto mb-8 mt-16 max-w-[70.625rem] text-center text-lg font-bold text-[#8F8F8F] sm:text-[2rem] md:text-[3rem]"
		>
			{nbspify(
				"Potřebujete více informací? Kontaktujte nás prostřednictvím uvedených kontaktů, nebo využijte kontaktního formuláře. Jsme tu, abychom vám pomohli.",
			)}
		</p>
		<p class="text-md text-bito-black mx-auto max-w-[70.625rem] text-center font-extrabold md:text-[1.5rem]">
			{nbspify(
				"Jsme tu pro vás! Ať už potřebujete poradit s výběrem správného řešení nebo máte jakékoli dotazy, neváhejte nás kontaktovat. Náš tým odborníků je připraven vám pomoci s optimalizací skladovacích procesů a zajistit, že dostanete přesně to, co potřebujete.",
			)}
		</p>
	</div>

	<div class="mt-16">
		<div class="flex flex-col-reverse items-center justify-center gap-12 lg:flex-row">
			<div class="flex flex-col items-center gap-4 lg:items-start">
				<p class="text-primary max-w-[16.25rem] text-[2.25rem] font-bold md:max-w-full lg:max-w-[16.25rem]">
					{nbspify("BITO skladovací technika CZ s.r.o.")}
				</p>
				<p class="text-md text-bito-black flex flex-col font-bold">
					<span>{nbspify("Kolbenova 923/34a")}</span>
					<span>{nbspify("190 00 Praha 9")}</span>
					<span>{nbspify("Pragovka")}</span>
				</p>
				<p class="text-bito-black flex flex-col text-[1.5rem]/[1.2] font-extrabold">
					<a href="tel:00420733643229">
						{nbspify("+420 733 643 229")}
					</a>
					<a href="mailto:info.cz@bito.com">
						{nbspify("info.cz@bito.com")}
					</a>
					<span class="mt-[5px]">{nbspify("IČ 27298221")}</span>
				</p>
			</div>

			<div class="flex flex-col gap-5 md:flex-row">
				{#each management as contact}
					<ContactCard {contact} />
				{/each}
			</div>
		</div>
	</div>

	<div class="mt-24 flex flex-col items-center px-4 md:px-6 lg:px-10">
		<DecoratedHeadline>{nbspify("Naši experti v okolí")}</DecoratedHeadline>
		<Icon icon={contactMap} class="mt-20 !aspect-auto w-full max-w-[70.625rem]" />
		<div class="mt-24 flex flex-wrap justify-center gap-5">
			{#each expert as contact, index}
				<ContactCard
					{contact}
					index={String(index + 1)}
					indexClass={contact.contactPosition.expert !== undefined
						? expertContactClasses[contact.contactPosition.expert - 1]
						: ""}
				/>
			{/each}
		</div>
	</div>

	<div class="mt-32">
		<Contact />
	</div>
</Layout>
